<template>
  <div
    :class="$style.root"
    :data-empty="!entries?.length ? '' : null"
  >
    <div :class="$style.group">
      <CoreBlocksWorksGroupLinkComponent
        v-for="(item, index) in entries"
        :key="item?.id"
        :item="item"
        :childPageName="childPageName"
        :index="index"
        :data-active="activeIndex === index ? '' : null"
        @mouseenter="activeIndex = index"
        @mouseleave="activeIndex = null"
      />

      <slot />
    </div>

    <div v-if="entries?.length" :class="$style.listContainer">
      <div :class="$style.label">
        {{ $t(`core.blocks.works.floor.${floor}`) }}
      </div>
      <ul :class="$style.list">
        <li v-for="(item, index) in entries" :class="$style.item">
          <I18nLinkWithFallback
            :name="childPageName"
            :localizedData="getLocalizedData(item)"
            :class="$style.link"
            :data-active="activeIndex === index ? '' : null"
            data-modal-link
            @mouseenter="activeIndex = index"
            @mouseleave="activeIndex = null"
          >
            <span
              v-html="`${getTitle(item)}`"
            />
          </I18nLinkWithFallback>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { camelCase } from 'lodash-es'

const props = defineProps({
  entries: {
    type: Array,
    required: false
  },
  childPageName: String
})

const activeIndex = ref(null)

const getLocalizedData = (item) => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(item))
}

const floor = computed(() => {
  return camelCase(props?.entries?.[0]?.attributes?.floor || '')
})

const getTitle = (item) => {
  const title = i18nGetLocalizedData(baseStrapiGetAttributes(item))?.titles?.current_locale || i18nGetLocalizedData(baseStrapiGetAttributes(item))?.titles?.i18n_string_en
  const author = i18nGetLocalizedData(baseStrapiGetAttributes(item))?.authors?.current_locale || i18nGetLocalizedData(baseStrapiGetAttributes(item))?.authors?.i18n_string_en
  if (title && author) {
    return `<em>${title?.trim()}</em>, ${author}`
  } else {
    return `<em>${title}</em>`
  }
}
</script>

<style module lang=scss>
.root[data-empty] {
  @media (max-width: $breakpoint-m) {
    display: none;
  }
}

.group {
  display: flex;
  flex-direction: column;

  position: relative;
}

.listContainer {
  composes: font-size-small from global;
  margin-top: var(--unit--vertical);
}

.list {
  composes: reset-list from global;
}

.list li {
  counter-increment: list-item;
  grid-template-columns: 2.5ch auto;
  display: grid;
}

.list li::before {
  content: counter(list-item, decimal) ".\a0";
}

.label {
  text-transform: uppercase;
}

.link {
  composes: reset-link from global;
  margin-right: auto;
}

.item:has(.link[data-active]),
.item:has(.link:global(.router-link-exact-active)),
.item:has(.link:hover) {
  color: var(--color--accent);
}

.root[data-type="garden"] .group {
  width: calc(var(--width, 100%) - (var(--unit--horizontal--tripple) * 2));
  margin: auto;
  @media (max-width: $breakpoint-m) {
    width: 100%;
  }
}
</style>
